import { Attribution } from "@endavaaccorplus/payments-common/schemas";

export const getSourceAttribute = (origin?: Attribution["origin"]) => {
  switch (origin) {
    case "ACDC":
      return "ACDC";
    case "qr-hotel-sale":
      return "QR Code";
    case "engage":
      return "Engage";
    case "zendesk":
      return "Zendesk";
    case "express-checkout":
      return "Express renewals";
    default:
      return "Public";
  }
};
